// Primary navigation for the student app shell.
//
// The top bar lists the SECTIONS; the left panel shows the submenu for the
// section the current route belongs to (see SidePanelNav). Routes declare
// their section via `meta.section` in router.js; nested routes inherit the
// nearest ancestor's section through routeSection().

// Below this window width the side panel auto-collapses to its icon rail and,
// when expanded, slides over the content instead of pushing it.
export const NARROW_BREAKPOINT = 1200;

export const SECTIONS = [
    {key: 'dashboard', label: 'Dashboard', icon: 'fa-home', route: {name: 'dashboard'}},
    {key: 'courses', label: 'Courses', icon: 'fa-chalkboard-teacher', route: {name: 'enrollments'}},
    {key: 'conferences', label: 'Conferences', icon: 'fa-presentation', route: {name: 'registrations'}},
    // Clock-hour users only (TopNav drops it while the certification is off);
    // `short` is the label on narrow desktop widths
    {key: 'pd', label: 'Professional Development', short: 'PD', icon: 'fa-arrow-trend-up', route: {name: 'pd'}, certification: 1},
    {key: 'records', label: 'Certificates & Forms', icon: 'fa-file-certificate', route: {name: 'reports'}},
];

// Utility sections live on the right side of the top bar rather than in the
// primary list. They still own a submenu (Your Account) or none (Support).
export const UTILITY_SECTIONS = [
    {key: 'account', label: 'Your Account', icon: 'fa-user-circle', route: {name: 'account'}},
    {key: 'support', label: 'Support', icon: 'fa-life-ring', route: {name: 'support'}},
];

export const ALL_SECTIONS = [...SECTIONS, ...UTILITY_SECTIONS];

// Nearest `meta.section` on the matched route chain (leaf first)
export function routeSectionKey(route) {
    if (!route || !route.matched) return null;
    for (let i = route.matched.length - 1; i >= 0; i--) {
        const meta = route.matched[i].meta;
        if (meta && meta.section) return meta.section;
    }
    return null;
}

export function routeSection(route) {
    const key = routeSectionKey(route);
    return ALL_SECTIONS.find(s => s.key === key) || null;
}

// Whether the left panel should render at all for this route. A route can opt
// out with `meta: {side: false}` (dashboard, support) — the section then takes
// the full width.
export function routeShowsSide(route) {
    if (!route || !route.matched) return true;
    for (let i = route.matched.length - 1; i >= 0; i--) {
        const meta = route.matched[i].meta;
        if (meta && typeof meta.side === 'boolean') return meta.side;
    }
    return true;
}
